// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2v8T-","bigColWidth":"Table_bigColWidth__csvtV","biggerColWidth":"Table_biggerColWidth__2RQdB","row":"Table_row__iCikm","col":"Table_col__2mdeq"};